import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function renewLicense(body: { newDate: string }, id: number) {
  return requests.put(`${LicenseEndpoints.LICENSE}/${id}/renew`, body)
}

export default renewLicense
